<template>
  <v-app-bar dark absolute color="transparent" flat height="85">
    <v-container class="px-0 text-right d-flex align-center">
      <v-toolbar-title class="font-weight-light hidden-xs-only" v-text="title" />

      <v-spacer />

      <v-btn v-for="(item, i) in items" :key="i" :to="item.to" min-height="48" min-width="40" text>
        <v-icon :left="$vuetify.breakpoint.mdAndUp" size="20" v-text="item.icon" />

        <span class="hidden-sm-and-down" v-text="item.text" />
      </v-btn>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  name: "PagesCoreAppBar",
  computed: {
    items() {
      let items = [
        {
          icon: "mdi-fingerprint",
          text: this.$t("login"),
          to: "/auth/login",
        },
      ];
      if (window.systemData.SYSTEM.disable_register !== "1")
        items.push({
          icon: "mdi-account-multiple-plus",
          text: this.$t("register"),
          to: "/auth/register",
        });
      return items;
    },
    title() {
      if (
        window.systemData &&
        window.systemData.ASD &&
        window.systemData.ASD.ragSoc
      )
        return window.systemData.ASD.ragSoc;
      else if (
        window.systemData &&
        window.systemData.SYSTEM &&
        window.systemData.SYSTEM.title
      )
        return window.systemData.SYSTEM.title;
      else return "MyASD";
    },
  },
};
</script>
